import type { LoggerConfig, LogLevel } from "./types";

export const LOG_LEVELS: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  fatal: 4,
};

function getEnvironmentLogLevel(): LogLevel {
  const env = process.env.REACT_APP_ENV ?? "development";
  const logLevel = process.env.LOG_LEVEL as LogLevel;

  const defaultLevels: Record<string, LogLevel> = {
    development: "debug",
    test: "warn",
    staging: "info",
    production: "error",
  };

  return logLevel || defaultLevels[env] || "info";
}

export const getLoggerConfig: () => LoggerConfig = () => ({
  level: getEnvironmentLogLevel(),
  environment: process.env.REACT_APP_ENV ?? "development",
  version: process.env.NEXT_PUBLIC_APP_VERSION || "1.0.0",
  enableConsole: process.env.ENABLE_CONSOLE_LOGS !== "false", // Default to true, disable with explicit false
});

export function shouldLog(level: LogLevel): boolean {
  const loggerConfig = getLoggerConfig();
  return LOG_LEVELS[level] >= LOG_LEVELS[loggerConfig.level];
}
